var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-wrap"},[_c('div',{staticClass:"card-top"},[_vm._t("top")],2),_c('div',{staticClass:"card-bottom"},[_vm._t("bottom")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }